export const DESKTOP_MEDIA_QUERY = 'only screen and (min-width: 769px)'
export const TABLET_MEDIA_QUERY = 'only screen and (min-width: 769px)'
export const MOBILE_MEDIA_QUERY = 'only screen and (min-width: 769px)'
